
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useMemo } from 'react';
import { RouterProvider } from 'react-router-dom';

import { AlertBar } from '@/components/AlertBar';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { router } from '@/router';
import { queryClient } from '@/services/queryClient';
import { useThemeStore } from '@/store/themeStore';
import { darkTheme, lightTheme } from '@/theme/theme';

export const App = (): JSX.Element => {
  const { mode } = useThemeStore();
  const theme = useMemo(() => (mode === 'dark' ? darkTheme : lightTheme), [mode]);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ErrorBoundary>
          <RouterProvider router={router} />
          <AlertBar />
        </ErrorBoundary>
      </ThemeProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};
